'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/message/style/css.js
// module id = 164
// module chunks = 0